import * as ActionTypes from "./actionTypes";

export function getUser() {
	return { type: ActionTypes.GET_USER };
}
export function getUserSuccess(user) {
	return { type: ActionTypes.GET_USER_SUCCESS, user };
}
export function getUserFail(error) {
	return { type: ActionTypes.GET_USER_FAIL, error };
}
export function userDoesNotExist() {
	return { type: ActionTypes.USER_DOES_NOT_EXIST };
}
export function createUser(data) {
	return { type: ActionTypes.CREATE_USER, data };
}
export function selectUser(userID) {
	return { type: ActionTypes.SELECT_USER, userID };
}
export function selectUserSuccess(user) {
	return { type: ActionTypes.SELECT_USER_SUCCESS, user };
}
